import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useWalletProvider } from "../useWalletProvider";
import { AppContext } from "../../AppContextProvider";
import { useTranslation } from "react-i18next";
export const WalletError = () => {
    const { t } = useTranslation();
    const { errorMessage, clearError } = useWalletProvider();
    const isError = !!errorMessage;
    const context = useContext(AppContext);
    return (_jsx("div", { className: "d-flex align-items-center justify-content-center pb-3", children: isError && (_jsxs("button", { className: "button accent large", onClick: () => {
                clearError();
                context.isLogin(false);
            }, children: [_jsxs("strong", { children: [t("common.status.error"), ":"] }), " ", errorMessage] })) }));
};
